import React from 'react';
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
    return (
        <footer className="bg-white dark:bg-primary-light py-4 border-t border-gray-200 dark:border-gray-700">
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <p className="text-sm text-gray-600 dark:text-gray-400">
                        &copy; {new Date().getFullYear()} DevsBestFriend - Tools
                        for Developers
                    </p>

                    <div className="mt-2 md:mt-0 flex space-x-4">
                        <Link
                            to="/about"
                            className="text-sm text-gray-600 dark:text-gray-400 hover:text-secondary dark:hover:text-secondary"
                        >
                            About
                        </Link>
                        <Link
                            to="/contact"
                            className="text-sm text-gray-600 dark:text-gray-400 hover:text-secondary dark:hover:text-secondary"
                        >
                            Contact
                        </Link>
                        <Link
                            to="/privacy"
                            className="text-sm text-gray-600 dark:text-gray-400 hover:text-secondary dark:hover:text-secondary"
                        >
                            Privacy
                        </Link>
                    </div>

                    <p className="mt-2 md:mt-0 text-xs text-gray-500 dark:text-gray-500">
                        Made with <span className="text-red-500">♥</span> for
                        developers from Dev's Best Friend
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
